import { fromJS } from 'immutable';
import { camelizeKeys } from 'humps';

import { pipe } from '../pipe';

export const fromRubyToImmutable = pipe(camelizeKeys, fromJS);
